import apiService from '@/services/apiService'

const Clients = {
  getClients () {
    return new Promise((resolve, reject) => {
      apiService.get('api/clients')
      .then(result => {
				console.log(result)
        if (result.data && result.data.clients) {
          // console.log('Clients info: ', result.data);
          resolve(result.data.clients)
        } else {
          reject()
        }
      }).catch(error => reject(error))
    })
  },
		getClientById (clientId) {
			return new Promise((resolve, reject) => {
				apiService.get(`api/clients/${clientId}`).then(result => {
					if (result.data) {
						resolve(result.data.client)
					} else {
						reject()
					}
				}).catch(error => reject(error))
			})
		},
  editClient (client) {
    return new Promise((resolve, reject) => {
    apiService.post('api/update-client', client).then((result) => {
					if (result.data.success) {
						resolve(result.data.user)
					} else {
						reject(new Error(result.data.message))
					}
				}).catch((error) => {
					reject(error)
				})
    })
  },
  addClient (client) {
    return new Promise((resolve, reject) => {
      // console.log({client})
      apiService.post('api/clients', client)
      .then(result => {
        // console.log({result})
        if (result.data && result.data.user) {
          resolve(result.data.user)
        } else {
          reject()
        }
      })
      .catch(error => reject(error))
    })
  },
  getClientEstateById (clientId) {
		return new Promise((resolve, reject) => {
      apiService.get(`api/estate/private/${clientId}`)
      .then(result => {
        if (result.data) {
          // console.log(result.data)
          resolve(result.data)
        } else {
          reject()
        }
      }).catch(error => reject(error))
    })
  },
}

export default Clients



// WEBPACK FOOTER //
// ./src/services/api/clients.js